// Database Link Hook
// uses a promise to wait for user input from the database link
import { useState, useRef } from "react";
import { Button, Container, Row, Col, Form } from 'react-bootstrap';

function useDatabaseLink() {
  const [ resolver, setResolver ] = useState({ resolver: null });
  const [openModal, setOpenModal] = useState(false);
  const [databaseLinkData, setDatabaseLinkData] = useState({client_id: "", client_location_id: ""});
  const [chosenClient, setChosenClient] = useState({id: ''});
  const [chosenLocation, setChosenLocation] = useState('');
  const databaseLinkOriginalRef = useRef({client_id: "", client_location_id: ""});

  const createPromise = () => {
    let resolver;
        return [ new Promise(( resolve, reject ) => {

            resolver = resolve
        }), resolver]
  };

  const getDatabaseLink = async (clientDatabaseInfo, clientId, clientLocationId) => {
    setDatabaseLinkData({
        ...databaseLinkData,
        client_id: clientId,
        client_location_id: clientLocationId
    });
    databaseLinkOriginalRef.current = {
        ...databaseLinkOriginalRef.current,
        client_id: clientId,
        client_location_id: clientLocationId
    }
    const clientInfo = clientDatabaseInfo.find((client)=> client.id === clientId);
    let locationIndex = '';
    if(clientInfo.id !== ''){
        setChosenClient(clientDatabaseInfo.find((client)=> client.id === clientInfo.id))
        locationIndex = clientInfo.Locations.findIndex((loc)=> loc.id === clientLocationId);
    }
    
    console.log(locationIndex);
    setChosenLocation(locationIndex);
    setOpenModal(true);
    const [ promise, resolve ] = await createPromise()
    setResolver({ resolve })
    return promise;
  };

  const sendDatabaseLink = (type)=>{
    setOpenModal(false);
    if(type === 'save'){
        resolver.resolve(databaseLinkData);
    }
    if(type === 'cancel'){
        resolver.resolve(databaseLinkOriginalRef.current);
    }
  };


  const DatabaseLinkModal = ({clientDatabaseInfo, clientId, clientLocationId}) => {
    const findChosenClientInfoFromID = ((id)=>{
        console.log(clientDatabaseInfo.find((client)=> client.id === id))
        return clientDatabaseInfo.find((client)=> client.id === id)
    });

    const clearForm = ()=>{
        setDatabaseLinkData({
            ...databaseLinkData,
            client_location_id: ""
        });
        setChosenLocation("");
    }
    return (
        <>
            {openModal && 
                <div  style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0, 0, 0, 0.5)', zIndex: 999, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <dialog
                        open
                    >
                        <Container>
                            <Row className="fs-4">
                                Choose Client Database Link:
                            </Row>
                            <Row className="mt-2">
                                {/** setDatabaseLinkData */}
                                <Form.Group  style={{textAlign:"left"}} id="set-client-list">
                                    <Form.Label>Choose Customer From List:</Form.Label>
                                    <Form.Select value={databaseLinkData.client_id} onChange={(event)=>{
                                        const loc = findChosenClientInfoFromID(event.target.value)
                                        setChosenClient(loc);
                                        setDatabaseLinkData({
                                            ...databaseLinkData,
                                            client_id: event.target.value,
                                            client_location_id: ""
                                        });
                                        setChosenLocation("");
                                    }}>
                                        {
                                            clientDatabaseInfo.map((client, index)=>{
                                                return(
                                                    <option key={index} value={client.id}>
                                                        {client?.["Customer"] === undefined ? "" : client?.["Customer"]}
                                                    </option>
                                                )
                                            })
                                        }
                                    </Form.Select>
                                </Form.Group>
                            </Row>
                            {
                                chosenClient?.Locations !== undefined &&
                                    chosenClient?.Locations.length > 0 ?
                                        <div className="w-100" style={{maxWidth: "600px"}}>
                                            <div className="mt-3">
                                                <Form>
                                                    <Form.Group  style={{textAlign:"left"}} id="set-client-list">
                                                        <Form.Label>Choose Location:</Form.Label>
                                                        <Form.Select value={chosenLocation} onChange={(event)=>{
                                                                setDatabaseLinkData({
                                                                    ...databaseLinkData,
                                                                    client_location_id: chosenClient.Locations[parseInt(event.target.value)]?.id === undefined ? "" : chosenClient.Locations[parseInt(event.target.value)].id,
                                                                });
                                                                setChosenLocation(parseInt(event.target.value));
                                                            }}>
                                                            <option value=''></option>
                                                            {
                                                                chosenClient.Locations.map((location, index)=>{
                                                                    return(
                                                                        <option key={index} value={index}>
                                                                            {location?.Address !== undefined ? location.Address : ''}
                                                                        </option>
                                                                    )
                                                                })
                                                            }
                                                        </Form.Select>
                                                    </Form.Group>
                                                </Form>
                                            </div>
                                        </div>
                                    :
                                        <div className="w-100" style={{maxWidth: "600px"}}>
                                            <div className="mt-3">
                                                <Form.Group  style={{textAlign:"left"}} id="set-client-list">
                                                    <Form.Label>Choose Location:</Form.Label>
                                                    <Form.Select>
                                                        <option value=''></option>
                                                    </Form.Select>
                                                </Form.Group>
                                            </div>
                                        </div>
                            }
                            <Row className="mt-4">
                                <Col lg="4" style={{textAlign:'right'}}>
                                    <Button
                                        onClick={()=>{
                                            clearForm();
                                            sendDatabaseLink('cancel');
                                        }}
                                        className="btn-dark"
                                        style={{backgroundColor:"#2596be", margin:5}}
                                    >
                                        Cancel
                                    </Button>
                                </Col>
                                <Col lg="8" style={{textAlign:'right'}}>
                                    <Button
                                        onClick={()=>{
                                            sendDatabaseLink('save');
                                            clearForm();
                                        }}
                                        className="btn-dark"
                                        style={{backgroundColor:"#2596be", margin:5}}
                                    >
                                        Continue
                                    </Button>
                                </Col>
                            </Row>
                        </Container>
                    </dialog>
                </div>
            }
        </>
    )
  };

    return [getDatabaseLink, DatabaseLinkModal];
}

export default useDatabaseLink;